const socialLinks = [
  { icon: 'ri-instagram-line', href: 'https://instagram.com', label: 'Instagram' },
  { icon: 'ri-facebook-circle-line', href: 'https://facebook.com', label: 'Facebook' },
  { icon: 'ri-linkedin-box-line', href: 'https://linkedin.com', label: 'LinkedIn' },
  { icon: 'ri-whatsapp-line', href: 'https://wa.me/5541999379470', label: 'WhatsApp' },
];

const navLinks = [
  { label: 'Sobre', href: '#sobre' },
  { label: 'Serviços', href: '#servicos' },
  { label: 'Portfólio', href: '#portfolio' },
  { label: 'Contato', href: '#contato' },
];

export default function Footer() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#111111] border-t border-[#2F2F2F]/60">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {/* Col 1: Logo + Description */}
          <div>
            <img
              src="https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/a6719c99-f0d6-4ea7-b741-aecd2aa3bb32_logo-mares-Photoroom.png?v=5f0652c94aa2d2624baec1f6dfcf5bd8"
              alt="André Mares Arquitetura"
              className="h-[68px] w-auto object-contain mb-5"
            />
            <p className="font-['Montserrat'] text-[#EDEDED]/60 text-sm leading-relaxed max-w-[260px]">
              Projetos residenciais, edifícios e empreendimentos em Curitiba, litoral e região metropolitana do Paraná.
            </p>
          </div>

          {/* Col 2: Navigation */}
          <div>
            <p className="font-['Montserrat'] text-xs tracking-[3px] uppercase text-[#A3B18A] mb-6">
              Navegação
            </p>
            <nav className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
                  className="font-['Montserrat'] text-[#EDEDED]/60 text-sm hover:text-[#A3B18A] transition-colors duration-300 cursor-pointer w-fit"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Col 3: Social */}
          <div>
            <p className="font-['Montserrat'] text-xs tracking-[3px] uppercase text-[#A3B18A] mb-6">
              Redes Sociais
            </p>
            <div className="flex gap-3 flex-wrap">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  aria-label={social.label}
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-[#2F2F2F] text-[#EDEDED]/60 hover:border-[#A3B18A] hover:text-[#A3B18A] hover:scale-110 transition-all duration-300 cursor-pointer"
                >
                  <i className={`${social.icon} text-lg`} />
                </a>
              ))}
            </div>
            <div className="mt-8">
              <p className="font-['Montserrat'] text-xs tracking-[3px] uppercase text-[#A3B18A] mb-3">
                Contato
              </p>
              <a
                href="https://wa.me/5541999379470"
                target="_blank"
                rel="noopener noreferrer"
                className="font-['Montserrat'] text-[#EDEDED]/60 text-sm hover:text-[#A3B18A] transition-colors duration-300 cursor-pointer"
              >
                (41) 99937-9470
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-[#2F2F2F]/40">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-['Montserrat'] text-[#EDEDED]/40 text-xs">
            © 2025 André Mares Arquitetura. Todos os direitos reservados.
          </p>
          <a
            href="https://startdigital1.com.br"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="font-['Montserrat'] text-xs text-[#EDEDED]/40 hover:text-[#A3B18A] transition-colors duration-300 cursor-pointer whitespace-nowrap"
          >
            Desenvolvido por{' '}
            <span className="text-[#A3B18A]">Start Digital</span>
          </a>
        </div>
      </div>
    </footer>
  );
}
